import React from 'react';
import TodayDeliveriesListFunctional from './components/today-deliveries-list-functional';
import './today-deliveries.scss';

const TodayDeliveriesList = () => {
	return <TodayDeliveriesListFunctional />;
};

export default TodayDeliveriesList;
